import { Link } from "@tanstack/react-router";
import { Newspaper, Shield } from "lucide-react";
import { ThemeToggle } from "@/components/theme-toggle";
import { UserMenu } from "@/components/user-menu";
import { NotificationBell } from "@/components/notifications";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useSuspenseQuery } from "@tanstack/react-query";
import { sessionQueryOptions } from "@/lib/auth.ts";
import { useNewRelease } from "@/hooks/use-new-release";

export function DashboardHeader() {
  const { data: session } = useSuspenseQuery(sessionQueryOptions);
  const { hasNewRelease, markSeen } = useNewRelease();

  return (
    <header className="bg-background/80 supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50 w-full border-b backdrop-blur-xl">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-6">
        <Link to="/dashboard" className="flex items-center gap-2.5">
          <img src="/BLDR.png" alt="BLDR" className="size-7 rounded-lg" />
          <span className="font-heading text-sm font-bold">BLDR</span>
          <div className="bg-border hidden h-4 w-px sm:block" />
          <span className="text-muted-foreground hidden text-xs sm:inline">
            Dashboard
          </span>
        </Link>
        <div className="flex items-center gap-1.5">
          {session?.user?.isAdmin && (
            <Button
              variant="ghost"
              size="sm"
              asChild
              className="gap-1.5 text-rose-500 hover:text-rose-400"
            >
              <Link to="/dashboard/admin">
                <Shield className="size-3.5" />
                <span className="hidden sm:inline">Admin</span>
              </Link>
            </Button>
          )}
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="relative size-8"
                  asChild
                >
                  <Link to="/dashboard/changelog" onClick={markSeen}>
                    <Newspaper className="size-3.5" />
                    {hasNewRelease && (
                      <span className="absolute right-1 top-1 size-2 rounded-full bg-rose-500" />
                    )}
                    <span className="sr-only">Changelog</span>
                  </Link>
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                {hasNewRelease ? "New update available" : "Changelog"}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          <NotificationBell />
          <ThemeToggle />
          {!!session && <UserMenu user={session.user} />}
        </div>
      </div>
    </header>
  );
}
